import { api } from '@/utils/api'

import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaRe150 {
  // GET parameters
  export namespace Post {
    // API Request
    export interface Request {
      query: {
        monthlyCheckId: string
      }
      body: {
        answerInfo: {
          questionType: number,
          monthlyCheckQuestionId: string
          monthlyCheckAnswerAdviceId: string
        }[]
      }
    }

    // API Response
    export type Response = {
      memNum: string,
      grade: number,
      fiscalYear: number,
      dispMonth: number,
      answerAdvicesInfo: {
        questionType: number,
        monthlyCheckAnswerAdviceId: string,
      }[]
    }
  }

  // API Path
  const path: string = '/ta/monthlyCheck'

  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {
    public post<R>(params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler:ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

      // 成功時のレスポンス構造サンプル
      const validationSample: Post.Response = {
        memNum: '',
        grade: 0,
        fiscalYear: 0,
        dispMonth: 0,
        answerAdvicesInfo: [{
          questionType: 0,
          monthlyCheckAnswerAdviceId: '',
        }]
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: ''
        }
      }

      // API呼び出し
      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(path, params.body, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample)
    }
  }
}